'use client';

import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

export default function HeroSection() {
  return (
    <section className="relative h-[600px] lg:h-[700px] overflow-hidden">
      <div className="absolute inset-0">
        <AppImage
          src="/assets/images/Entrance-1767660169249.jpg"
          alt="Proximus serviced apartments entrance showcasing modern architecture and welcoming facade"
          className="w-full h-full object-cover"
          priority
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary/90 via-primary/70 to-transparent" />
      </div>

      <div className="relative h-full flex items-center">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-2xl space-y-6">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full">
              <Icon name="HomeIcon" size={20} className="text-accent" />
              <span className="text-white text-sm font-medium">Trusted Leader in Premium Serviced Apartments</span>
            </div>
            <h1 className="text-4xl lg:text-6xl font-display font-bold text-white leading-tight">
              Redefining Business Hospitality
            </h1>
            <p className="text-lg lg:text-xl text-white/90">
              At Proximus, we blend the comfort of home with the luxury of premium hotels, creating exceptional experiences for business travelers and extended-stay guests in Bangalore.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <a
                href="https://bookingengine.stayflexi.com/?hotel_id=33526"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-accent hover:bg-accent/90 text-white font-semibold rounded-lg shadow-elevated transition-all duration-300 hover:scale-105 flex items-center justify-center space-x-2"
              >
                <span>Book Your Stay</span>
                <Icon name="CalendarIcon" size={20} className="text-white" />
              </a>
              <a
                href="/apartment-categories"
                className="px-8 py-4 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-semibold rounded-lg border-2 border-white/30 transition-all duration-300 flex items-center justify-center space-x-2"
              >
                <span>View Apartments</span>
                <Icon name="HomeIcon" size={20} className="text-white" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}